import { render } from "./Navbar.vue?vue&type=template&id=1590443d&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=1590443d&scoped=true&lang=css"

import exportComponent from "D:\\Working\\GLMA\\baik\\baicpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1590443d"]])

export default __exports__